export const SHOW_LOADER = 'commons/SHOW_LOADER';
export const HIDE_LOADER = 'commons/HIDE_LOADER';

export const SET_RESPONSE_MODAL = 'commons/SET_RESPONSE_MODAL';

export const SET_AGENT_STAFF_ID = 'commons/SET_AGENT_STAFF_ID';
export const SET_AGENT_TABLE_ID = 'commons/SET_AGENT_TABLE_ID';
